import { type ReactNode, useEffect } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from './msalConfig';

/**
 * Wrapper qui force un login si l'utilisateur n'est pas authentifié.
 * Affiche un splash discret pendant la redirection.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (!isAuthenticated && inProgress === 'none') {
      instance.loginRedirect(loginRequest).catch(console.error);
    }
  }, [isAuthenticated, inProgress, instance]);

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-xl bg-teal flex items-center justify-center text-white text-2xl font-bold">
            c
          </div>
          <p className="mt-4 text-ink-sub text-sm">Connexion en cours…</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
